__turbopack_context__.v({
  "actions": "LogoutModal-module__fCUdAq__actions",
  "cancelBtn": "LogoutModal-module__fCUdAq__cancelBtn",
  "confirmBtn": "LogoutModal-module__fCUdAq__confirmBtn",
  "description": "LogoutModal-module__fCUdAq__description",
  "modal": "LogoutModal-module__fCUdAq__modal",
  "overlay": "LogoutModal-module__fCUdAq__overlay",
  "root": "LogoutModal-module__fCUdAq__root",
  "title": "LogoutModal-module__fCUdAq__title",
});
